import { getDisplayDate, getDisplayTime } from "../utilities/get-display-date";

export const genericError = {
  title: "Something Went Wrong...",
  message: "Sorry, something went wrong. Please try again later...",

  type: "error",
};

export const successEnteringDraw = (drawDate, tsAndCsLink) => ({
  title: "You're in the Draw!",
  message: `Thank you for your entry. The draw will take place at ${getDisplayTime(
    drawDate
  )} (local time) on ${getDisplayDate(
    drawDate
  )}. You will be notified if you have been selected. Please check your emails.`,
  link: {
    text: "Terms and Conditions apply",
    href: tsAndCsLink,
  },
  type: "success",
});

export const alertAlreadyInDraw = (drawDate, tsAndCsLink) => ({
  title: "You're already in the Draw!",
  message: `Thank you for your entry. The draw will take place at ${getDisplayTime(
    drawDate
  )} (local time) on ${getDisplayDate(
    drawDate
  )}. You will be notified if you have been selected. Please check your emails.`,
  link: {
    text: "Terms and Conditions apply",
    href: tsAndCsLink,
  },
  type: "alert",
});

export const alertPremierOnlyDraw = (signupLink) => ({
  title: "Premier Customers Only",
  message: `This product drop is exclusive to Premier customers only.  To join the club sign up to ASOS Premier.`,
  link: {
    text: "To join the club sign up to ASOS Premier",
    href: signupLink,
  },
  type: "alert",
});

export default {
  genericError,
  successEnteringDraw,
  alertAlreadyInDraw,
  alertPremierOnlyDraw,
};
